export default __webpack_public_path__ + "static/media/02_srnec_info-min.59cc1839.jpg";